import React from 'react';

import ComingSoon from '../../ComingSoon';

export const TroubleshootingDetailTickets = () => (
    <>
        <ComingSoon></ComingSoon>
    </>
);
